import { useEffect, useState } from 'react';
import styles from './nav.module.css';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);
const Nav = (props) => {
  const [navItems, setNavItems] = useState([
    {
      name: 'Timeline',
      id: 0,
    },
    {
      name: 'The Categories',
      id: 1,
    },
    {
      name: 'How to Enter',
      id: 2,
    },
    {
      name: 'The Prizes',
      id: 3,
    },
    {
      name: 'Terms of Service',
      id: 4,
    },
    {
      name: 'APPLY FOR FREE SMOOTH 5',
      id: 5,
    },
  ]);

  const [activeSectionIndex, setActiveSectionIndex] = useState(-1);

  const scrollTo = (index) => {
    gsap.to(window, {
      duration: 1,
      scrollTo: {
        y: document.getElementById(`sm5-active${index}`),
        offsetY: 72,
      },
    });
  };

  useEffect(() => {
    window.addEventListener('load', () => {
      document
        .querySelectorAll('.sm5-active-section')
        .forEach((item, index) => {
          ScrollTrigger.create({
            trigger: item,
            start: 'top 90%',
            onEnter: () => {
              setActiveSectionIndex(index);
              // document.querySelector(`.${styles.ctn}`).scrollTo(scrollX,0)
              gsap.to(`.${styles.ctn}`, {
                duration: 0.2,
                scrollTo: { x: document.querySelectorAll(`.${styles.item}`)[index], offsetX:window.innerWidth / 2 - (document.querySelectorAll(`.${styles.item}`)[index].offsetWidth / 2)},
                ease: 'power2',
              });
            },
            onLeaveBack: () => {
              setActiveSectionIndex(index - 1);
              gsap.to(`.${styles.ctn}`, {
                duration: 0.2,
                scrollTo: { x: document.querySelectorAll(`.${styles.item}`)[index - 1] , offsetX:window.innerWidth / 2 - (document.querySelectorAll(`.${styles.item}`)[index].offsetWidth / 2)},
                ease: 'power2',
              });
            },
          });
        });
    });
  });
  return (
    <div className={styles.ctn}>
      <div className={styles.box}>
        {navItems.map((item, index) => {
          return (
            <h4
              className={`${item.id === activeSectionIndex ? 'active' : ''} ${
                styles.item
              }`}
              onClick={() => {
                scrollTo(item.id);
              }}
              key={index}
            >
              {item.name}
            </h4>
          );
        })}
      </div>
    </div>
  );
};

export default Nav;
